export default "__VITE_ASSET__Z7HJ37sk__"